module.exports = __webpack_public_path__ + "static/img/place-icon.1bdd361b.svg";